<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">学籍异动</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-if="teaAuthVisible" v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable></el-input>
                        <el-select v-if="stuAuthVisible" v-model="queryForm.changeCode" filterable placeholder="异动类型" style="width:100%" clearable>
                            <el-option v-for="item in comboData.changeCode" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多</el-button>
                        <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i> {{ buttonName }}</el-button>
                    </div>
                </div>
            </div>
            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row v-if="teaAuthVisible">
                    <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable></el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.changeCode" filterable placeholder="异动类型" clearable>
                        <el-option v-for="item in comboData.changeCode" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.semesterCode" filterable placeholder="学年学期" clearable>
                        <el-option v-for="item in comboData.semester" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-date-picker type="date" placeholder="起始日期" v-model="queryForm.startTime" value-format="yyyy-MM-dd"></el-date-picker>
                </el-row>
                <el-row>
                    <el-date-picker type="date" placeholder="结束日期" v-model="queryForm.endTime" value-format="yyyy-MM-dd"></el-date-picker>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.auditState" placeholder="审核状态" clearable>
                        <el-option v-for="(item, index) in comboData.auditState" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有学籍异动记录</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</label>{{ item.stuCode }}</p>
                        <p><label for="">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>{{ item.stuName }}</p>
                        <p><label for="">异动类型：</label>{{ item.changeName }}</p>
                        <p><label for="">异动原因：</label>{{ item.reasonName }}</p>
                        <p><label for="">异动日期：</label>{{ item.changeTime }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput" >
                        <el-button v-if="item.submitState == '0'" type="warning" @click="modRec(item)">编辑</el-button>
                        <el-button v-if="item.submitState == '0'" type="success" @click="submitRec(item)">提交</el-button>
                        <el-button v-if="item.submitState == '0'" type="danger" @click="delRec(item)">删除</el-button>
                        <el-button v-if="item.submitState=='1' && item.auditAuth=='0'" type="primary" @click="showDetailInfo(item)">详情</el-button>
                        <el-button v-if="item.auditAuth == '1'" type="primary" @click="auditRec(item)">审核</el-button>
                        <el-button v-if="item.submitState=='1' || item.auditState!=''" @click="showAuditList(item)">审核信息</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="changeStatusForm" :model="curdForm" label-width="84px" label-position="left" width="100%" :rules="curdRules">
                        <el-form-item label="编号" prop="id" v-show="false">
                            <el-input v-model="curdForm.id"></el-input>
                        </el-form-item>
                        <el-row v-show="teaAuthVisible && fieldVisible">
                            <el-form-item label="学生" prop="stuInfo">
                                <el-autocomplete class="inline-input" v-model="stuInfo" :fetch-suggestions="querySearchStu" placeholder="可输入学号或姓名搜索学生"
                                      :trigger-on-focus="false" @clear="clearSelectStu" clearable style="width:100%;"></el-autocomplete>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="学生" prop="stuCode" v-show="stuAuthVisible || !fieldVisible">
                            {{ curdForm.stuCode + ' - ' + curdForm.stuName }}
                            <el-input v-model="curdForm.stuCode" v-show="false"></el-input>
                        </el-form-item>
                        <el-row v-if="fieldVisible">
                            <el-form-item label="异动类型" prop="changeCode">
                                <el-select v-model="curdForm.changeCode" filterable placeholder="请选择异动类型" style="width:100%;" @change="selectChangeType">
                                    <el-option v-for="item in comboData.changeCode" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="异动类型" prop="changeName" v-show="!fieldVisible">
                            {{ selectRowData.changeName }}
                        </el-form-item>

                        <el-row v-if="fieldVisible && reasonCodeVisible">
                            <el-form-item label="异动原因" prop="reasonCode">
                                <el-select v-model="curdForm.reasonCode" filterable placeholder="请选择异动原因" style="width:100%;">
                                    <el-option v-for="item in comboData.reasonCode" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="异动原因" v-show="!fieldVisible">
                            {{ selectRowData.reasonName }}
                        </el-form-item>

                        <el-row v-show="fieldVisible">
                            <el-form-item label="异动日期" prop="changeTime">
                                <el-date-picker type="date" placeholder="异动日期" v-model="curdForm.changeTime"  value-format="yyyy-MM-dd" style="width:100%;"  @change="handleTimeChange">
                                </el-date-picker>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="异动日期" v-show="!fieldVisible">
                            {{ selectRowData.changeTime }}
                        </el-form-item>

                        <el-row v-show="fieldVisible">
                            <el-form-item label="学年学期" prop="semesterCode">
                                <el-select v-model="curdForm.semesterCode" filterable placeholder="请选择学年学期" style="width:100%;">
                                    <el-option v-for="item in comboData.semester" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="学年学期" v-show="!fieldVisible">
                            {{ selectRowData.semesterName }}
                        </el-form-item>

                        <el-row v-if="fieldVisible && schoolVisible">
                            <el-form-item label="去向学校" prop="newSchoolCode">
                                <el-input v-model="curdForm.newSchoolCode" placeholder="请输入异动去向学校"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="去向学校" v-show="!fieldVisible && selectRowData.changeCode=='11'">
                            {{ selectRowData.newSchoolCode }}
                        </el-form-item>

                        <el-form-item label="原专业码" prop="oriMajorCode" v-show="false">
                            <el-input v-model="curdForm.oriMajorCode"></el-input>
                        </el-form-item>
                        <el-form-item label="原专业" prop="oriMajorName">
                            {{ curdForm.oriMajorName }}
                        </el-form-item>

                        <el-row v-if="fieldVisible && majorVisible">
                            <el-form-item label="现专业" prop="newMajorCode">
                                <el-select v-model="curdForm.newMajorCode" filterable placeholder="请选择现专业" style="width:100%" @change="loadClassCombo">
                                    <el-option v-for="item in comboData.major" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="现专业" v-show="!fieldVisible && (selectRowData.changeCode=='02' || selectRowData.changeCode=='06' || selectRowData.changeCode=='18')">
                            {{ selectRowData.newMajorName }}
                        </el-form-item>

                        <el-form-item label="原班级码" prop="oriClassCode" v-show="false">
                            <el-input v-model="curdForm.oriClassCode"></el-input>
                        </el-form-item>
                        <el-form-item label="原班级" prop="oriClassName">
                            {{ curdForm.oriClassName }}
                        </el-form-item>

                        <el-row v-if="fieldVisible && classVisible">
                            <el-form-item label="现班级" prop="newClassCode">
                                <el-select v-model="curdForm.newClassCode" filterable placeholder="请选择现班级" style="width:100%">
                                    <el-option v-for="item in comboData.class" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="现班级" v-show="!fieldVisible && (selectRowData.changeCode=='02' || selectRowData.changeCode=='06' || selectRowData.changeCode=='18')">
                            {{ selectRowData.newClassName }}
                        </el-form-item>

                        <el-form-item label="异动说明" prop="desc" v-show="fieldVisible">
                            <el-input v-model="curdForm.desc" placeholder="请填写异动说明" autoComplete="on" type="textarea"
                                :rows="5" show-word-limit maxlength="500"></el-input>
                        </el-form-item>
                        <el-form-item label="异动说明" v-show="!fieldVisible">
                            {{ selectRowData.desc }}
                        </el-form-item>
                    </el-form>
                </el-scrollbar>

                <div v-if="auditAreaVisible" slot="footer" class="dialog-footer">
                    <audit ref="audit" :itemCode="auditParam" :relatedCode="selectRowData?selectRowData.id:''" :auditLevel="selectRowData?selectRowData.auditLevel:''"
                        @auditCallback="auditCallback"></audit>
                </div>

                <div v-if="fieldVisible" slot="footer" class="dialog-footer text-center">
                    <el-button type="primary" :loading="formSubmiting" @click="saveRec">保 存</el-button>
                    <el-button style="margin-left: 10px;" type="success" :loading="formSubmiting" @click="saveAndSubmitRec">提 交</el-button>
                    <el-button style="margin-left: 10px;" @click="dialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <el-dialog class="formDialog" title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="90%">
                <div>
                    <auditList ref="auditList" :relatedCode="selectRowData.id" :listHeight="450"></auditList>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import { confirmMsg, showNotify } from "utils/message";
    import audit from './audit.vue';
    import auditList from './auditList.vue';

    export default {
        components: {
            audit,
            auditList,
        },
        data() {
            return {
                userRole: null,
                stuAuthVisible: false,
                teaAuthVisible: false,
                buttonName: '新建',
                loadingMask: null,
                comboData: {
                    semester: null,
                    changeCode: null,
                    exportChangeCode: null,
                    reasonCode: null,
                    major: null,
                    class: null,
                    auditState: null,
                },
                allReasonCodeOption: null,
                reasonCodeVisible: false,
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    stuCode: null,
                    stuName: null,
                    semesterCode: null,
                    changeCode: null,
                    startTime: null,
                    endTime: null,
                    itemCode: null,
                    auditState: null,
                },
                queryDialogVisible: false,
                tableData: [],
                currentPage: 1,
                total: null,
                tableLoading: false,
                selectRowData: {},
                mainTableHeight: 500,
                dialogTitle: '',
                dialogVisible: false,
                fieldVisible: true,
                schoolVisible: false,
                majorVisible: false,
                classVisible: false,
                students: [],
                stuInfo: null,
                curdForm: {
                    id: '',
                    stuCode: '',
                    stuName: '',
                    changeCode: '',
                    reasonCode: '',
                    oriSchoolCode: '',
                    newSchoolCode: '',
                    oriMajorCode: '',
                    oriMajorName: '',
                    newMajorCode: '',
                    newMajorName: '',
                    oriClassCode: '',
                    oriClassName: '',
                    newClassCode: '',
                    newClassName: '',
                    submitState: '0',
                    desc: '',
                    changeTime: '',
                    semesterCode: '',
                    auditItemCode: '',
                },
                curdRules: {
                    stuInfo: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            let isExist = false;

                            for(let i=0; i<this.students.length; i++){
                                if(this.students[i].value == this.stuInfo){
                                    this.curdForm.stuCode = this.students[i].stuCode;
                                    this.curdForm.stuName = this.students[i].stuName;
                                    this.curdForm.oriMajorCode = this.students[i].majorCode;
                                    this.curdForm.oriMajorName = this.students[i].majorName;
                                    this.curdForm.oriClassCode = this.students[i].classCode;
                                    this.curdForm.oriClassName = this.students[i].className;
                                    isExist = true;

                                    break;
                                }
                            }

                            if(isExist == false){
                                this.curdForm.stuCode = '';
                                this.curdForm.stuName = '';
                                this.curdForm.oriMajorCode = '';
                                this.curdForm.oriMajorName = '';
                                this.curdForm.oriClassCode = '';
                                this.curdForm.oriClassName = '';
                                callback(new Error("学生不存在"));
                            }else{
                                callback();
                            }
                        },
                        change: "blur",
                    }],
                    changeCode: [{
                            required: true,
                            message: "请选择异动类型",
                            trigger: ["blur", "change"],
                        }
                    ],
                    reasonCode: [{
                            required: true,
                            message: "请选择异动原因",
                            trigger: ["blur", "change"],
                        }
                    ],
                    changeTime: [{
                            required: true,
                            message: "请选择异动日期",
                            trigger: ["blur", "change"],
                        }
                    ],
                    semesterCode: [{
                            required: true,
                            message: "请选择学年学期",
                            trigger: ["blur", "change"],
                        }
                    ],
                    newMajorCode: [{
                            required: true,
                            message: "请选择现专业",
                            trigger: ["blur", "change"],
                        }
                    ],
                    newClassCode: [{
                            required: true,
                            message: "请选择现班级",
                            trigger: ["blur", "change"],
                        }
                    ],
                },
                formSubmiting: false,
                auditAreaVisible: false,
                auditListDialogVisible: false,
                auditParam: null,
            };
        },
        created(){
            this.init();
        },
        mounted() {
        },
        methods: {
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            loadStateImg(row){
                if(row.auditState==='1'){
                    //通过
                    return require('image/mobile/auditState/tg.png');
                }else if(row.auditState==='2'){
                    //驳回
                    return require('image/mobile/auditState/bh.png');
                }else{
                   if(row.submitState === '1'){
                       if(row.auditLevel === '1'){
                           //待审核
                           return require('image/mobile/auditState/dsh.png');
                       }else{
                           //审核中
                           return require('image/mobile/auditState/shz.png');
                       }
                   }else{
                       //未提交
                       return require('image/mobile/auditState/wtj.png');
                   }
                }
            },
            async init(){
                await this.queryUserInfo();
                await this.queryAuditParam();
                await this.queryList();
                this.initCombo();
            },
            async queryUserInfo() {
                await this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;

                    if (userInfo) {
                        let roleInfo = userInfo.roles;

                        for (var roleCode in roleInfo) {
                            // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                            this.userRole = roleInfo[roleCode];
                        }

                        if(this.userRole === '学生'){
                            this.stuAuthVisible = true;
                            this.curdForm.stuCode = userInfo.phone;
                            this.queryForm.stuCode = userInfo.phone;
                            // this.curdForm.stuCode = '20215060010101';
                            // this.queryForm.stuCode = '20215060010101';
                            this.curdForm.stuName = userInfo.name;
                            this.queryForm.stuName = userInfo.name;
                            // this.curdForm.stuName = '何睿';
                            // this.queryForm.stuName = '何睿';
                            this.stuInfo = this.curdForm.stuName + ' - ' + this.curdForm.stuCode;
                            this.buttonName = '申请';
                        }else{
                            this.teaAuthVisible = true;
                        }
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            async queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;

                await this.$api.student.status.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    // this.tableData = response.data.data.list;
                    this.tableData = this.tableData.concat(response.data.data.list);
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            requeryList(){
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
            },
            handleFilter() {
                this.requeryList();
                this.queryDialogVisible = false;
            },
            handleReset() {
                if(this.teaAuthVisible){
                    this.queryForm.stuCode = null;
                    this.queryForm.stuName = null;
                }
                this.queryForm.semesterCode = null;
                this.queryForm.changeCode = null;
                this.queryForm.startTime = null;
                this.queryForm.endTime = null;
                this.queryForm.auditState = null;
                this.requeryList();
                this.queryDialogVisible = false;
            },
            initCombo() {
                this.$api.student.status.initCombo({}).then((res) => {
                    this.comboData.semester = res.data.data.semesterComboData;
                    this.comboData.changeCode = res.data.data.changeCodeComboData;
                    this.comboData.exportChangeCode = res.data.data.exportChangeCodeComboData;
                    this.allReasonCodeOption = res.data.data.reasonCodeComboData;
                    this.comboData.major = res.data.data.majorComboData;
                    this.comboData.class = res.data.data.classComboData;
                    this.students = res.data.data.stuData;
                    this.comboData.auditState = res.data.data.auditStateComboData;

                    if(this.userRole == '学生'){
                        for(let i=0; i<this.students.length; i++){
                            if(this.students[i].stuCode == this.curdForm.stuCode){
                                this.curdForm.oriMajorCode = this.students[i].majorCode;
                                this.curdForm.oriMajorName = this.students[i].majorName;
                                this.curdForm.oriClassCode = this.students[i].classCode;
                                this.curdForm.oriClassName = this.students[i].className;
                                break;
                            }
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleScroll(){
                if(this.checkVisible() && !this.tableLoading && this.total>this.tableData.length){
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if(ele){
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }else{
                    return false;
                }
            },
            scrollToTop(){
                const ele = document.getElementById('listArea');
                if(ele){
                    ele.scrollTop = 0;
                }
            },
            querySearchStu(queryString, cb){
                let students = this.students;
                let results = queryString ? students.filter(this.createFilter(queryString)) : students;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (student) => {
                    return (student.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            handleSelectStu(item){
                this.curdForm.stuCode = item.stuCode;
                this.curdForm.stuName = item.stuName;
                this.curdForm.oriMajorCode = item.majorCode;
                this.curdForm.oriMajorName = item.majorName;
                this.curdForm.oriClassCode = item.classCode;
                this.curdForm.oriClassName = item.className;
            },
            clearSelectStu(){
                document.activeElement.blur();
            },
            handleTimeChange(value){
                let isExist = false;
                for(let i=0; i<this.comboData.semester.length; i++){
                    const dateRange = this.comboData.semester[i].otherInfo.split('@');

                    if(dateRange && value>=dateRange[0] && value<=dateRange[1]){
                        isExist = true;
                        this.curdForm.semesterCode = this.comboData.semester[i].comboValue;
                        break;
                    }
                }

                if(!isExist) this.curdForm.semesterCode = '';
            },
            //处理各种学籍异动相关显示内容
            selectChangeType(){
                if(this.curdForm.changeCode == '11'){ //转学
                    this.schoolVisible = true;
                    this.majorVisible = false;
                    this.curdForm.newMajorCode = '';
                    this.classVisible = false;
                    this.curdForm.newClassCode = '';
                }else if(this.curdForm.changeCode=='02' || this.curdForm.changeCode=='06' || this.curdForm.changeCode=='18'){//转专业、留级、复学
                    this.schoolVisible = false;
                    this.curdForm.newSchoolCode = '';
                    this.majorVisible = true;
                    this.classVisible = true;

                    if(this.curdForm.changeCode == '02'){
                        this.curdForm.newMajorCode = this.curdForm.oriMajorCode;
                    }
                }else{
                    this.schoolVisible = false;
                    this.curdForm.newSchoolCode = '';
                    this.majorVisible = false;
                    this.curdForm.newMajorCode = '';
                    this.classVisible = false;
                    this.curdForm.newClassCode = '';
                }

                //处理异动原因下拉框数据
                let reasonCodeArray = [];
                if(this.curdForm.changeCode == '06'){ //转专业
                    reasonCodeArray = ['04','05','21','22','99'];
                }else if(this.curdForm.changeCode == '08'){ //休学
                    reasonCodeArray = ['01','02','03','04','05','06','07','08','09','10','11','12','99'];
                }else if(this.curdForm.changeCode=='19' || this.curdForm.changeCode=='20'){ //保留学籍/保留入学资格
                    reasonCodeArray = ['13','14'];
                }else if(this.curdForm.changeCode == '18'){ //复学
                    reasonCodeArray = ['15','16','17'];
                }else if(this.curdForm.changeCode == '10'){ //退学
                    reasonCodeArray = ['18','19','20','21','22','23','24','25','26','27','99'];
                }
                this.handleReasonInfo(reasonCodeArray);
            },
            handleReasonInfo(reasonCodeArray){
                if(reasonCodeArray.length === 0){
                    this.reasonCodeVisible = false;
                }else{
                    let tempReasonOption = [];
                    this.allReasonCodeOption.forEach(function(option) {
                        if(reasonCodeArray.indexOf(option.comboValue) > -1){
                            tempReasonOption.push(option);
                        }
                    });

                    this.comboData.reasonCode = tempReasonOption;
                    this.curdForm.reasonCode = null;
                    this.reasonCodeVisible = true;
                }
            },
            loadClassCombo(){
                this.$api.student.status.loadClassComboByMajor({
                    data: { majorCode: this.curdForm.newMajorCode },
                }).then((res) => {
                    this.comboData.class = res.data.data.classComboData;
                    this.curdForm.newClassCode = '';
                }).catch((err) => {
                    console.log(err);
                });
            },
            addRec(){
                this.dialogTitle = "新建";
                this.dialogVisible = true;
                this.setMainDialogStyle('-60px', '80vh');
                this.restoreScroll();
                this.curdForm.changeTime = this.getCurrentFormatDate();
                this.handleTimeChange(this.curdForm.changeTime);

                if(this.$refs.changeStatusForm !== undefined){
                    this.$refs.changeStatusForm.clearValidate();
                }
            },
            modRec(rowData) {
                this.selectRowData = rowData;

                if (this.selectRowData == null) {
                    this.$alert("请先选择一条记录", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });

                    return;
                }

                this.dialogTitle = "编辑";
                this.dialogVisible = true;
                this.setMainDialogStyle('-60px', '80vh');
                this.restoreScroll();
                this.$nextTick(() => {
                    this.curdForm.id = this.selectRowData.id;
                    this.stuInfo = this.selectRowData.stuName + ' - ' + this.selectRowData.stuCode;
                    this.curdForm.stuCode = this.selectRowData.stuCode;
                    this.curdForm.stuName = this.selectRowData.stuName;
                    this.curdForm.changeCode = this.selectRowData.changeCode;
                    this.selectChangeType();
                    this.curdForm.reasonCode = this.selectRowData.reasonCode;
                    this.curdForm.semesterCode = this.selectRowData.semesterCode;
                    this.curdForm.changeTime = this.selectRowData.changeTime;
                    this.curdForm.oldMajorCode = this.selectRowData.oldMajorCode;
                    this.curdForm.oldMajorName = this.selectRowData.oldMajorName;
                    this.curdForm.newMajorCode = this.selectRowData.newMajorCode;
                    this.curdForm.oldClassCode = this.selectRowData.oldClassName;
                    this.curdForm.oldClassName = this.selectRowData.oldClassCode;
                    this.curdForm.newClassCode = this.selectRowData.newClassCode;
                    this.curdForm.desc = this.selectRowData.desc;
                    this.curdForm.submitState = this.selectRowData.submitState;
                });
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs['changeStatusForm'].validate((valid) => {
                    if (valid) {
                        this.$api.student.status.save({
                            data: this.curdForm,
                        }).then((response) => {
                            let state = response.data.data.state;
                            let msg = response.data.data.msg;

                            if (state == 'Success') {
                                showNotify('成功', msg ? msg : "保存成功", 'success', 1500);

                                this.requeryList();
                                this.closeDialog();
                            }else{
                                showNotify('失败', msg ? msg : "保存失败", 'error', 3000);
                            }
                        }).catch((error) => {
                            showNotify('错误', error, 'error', 3000);
                        });
                    } else {
                        return false;
                    }
                });

                this.formSubmiting = false;
            },
            saveAndSubmitRec(){
                confirmMsg('提交后将无法再修改学籍异动申请信息，是否继续？', 'el-message-box-mobile').then(() => {
                    this.curdForm.submitState = '1';
                    this.saveRec();
                });
            },
            submitRec(rowData){
                confirmMsg('提交后将无法再修改学籍异动申请信息，是否继续？', 'el-message-box-mobile').then(() => {
                    this.$api.student.status.submit({
                        data: {
                            id: rowData.id,
                            auditItemCode: this.curdForm.auditItemCode,
                        },
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', '提交成功', 'success', 1500);
                            this.requeryList();
                        }else{
                            showNotify('失败', '提交失败', 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除学籍异动信息？', 'el-message-box-mobile').then(() => {
                    this.curdForm.id = rowData.id;

                    this.$api.student.status.del({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', "删除成功", 'success', 1500);
                            this.requeryList();
                        }else{
                            showNotify('失败', "删除失败", 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            closeDialog() {
                this.curdForm.id = '';
                if(this.userRole != '学生'){
                    this.stuInfo = '';
                    this.curdForm.stuCode = '';
                    this.curdForm.stuName = '';
                    this.curdForm.oriMajorCode = '';
                    this.curdForm.oriMajorName = '';
                    this.curdForm.oriClassCode = '';
                    this.curdForm.oriClassName = '';
                }
                this.curdForm.semesterCode = '';
                this.curdForm.changeCode = '';
                this.curdForm.reasonCode = '';
                this.curdForm.oriSchoolCode = '';
                this.curdForm.newSchoolCode = '';
                this.curdForm.newSchoolCode = '';
                this.curdForm.newMajorCode = '';
                this.curdForm.newMajorName = '';
                this.curdForm.newClassCode = '';
                this.curdForm.newClassName = '';
                this.curdForm.submitState = '0';
                this.curdForm.desc = '';

                this.dialogVisible = false;
                this.fieldVisible = true;
                this.auditAreaVisible = false;
                this.schoolVisible = false;
                this.majorVisible = false;
                this.classVisible = false;
                this.reasonCodeVisible = false;
            },
            showDetailInfo(rowData){
                this.selectRowData = rowData;
                this.curdForm.stuCode = rowData.stuCode;
                this.curdForm.stuName = rowData.stuName;
                this.dialogTitle = '详情';
                this.setMainDialogStyle('20px', '70vh');
                this.dialogVisible = true;
                this.auditAreaVisible = false;
                this.fieldVisible = false;
            },
            //查询审核调用参数
            async queryAuditParam(){
                const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);

                await this.$api.common.audit.auditParam({
                    data: { pageName: pageName },
                }).then((res) => {
                    this.auditParam = res.data.data.auditParam;
                    this.queryForm.itemCode = this.auditParam;
                    this.curdForm.auditItemCode = this.auditParam;
                }).catch((err) => {
                    console.log(err);
                });
            },
            auditRec(rowData){
                this.selectRowData = rowData;
                this.curdForm.stuCode = rowData.stuCode;
                this.curdForm.stuName = rowData.stuName;
                this.dialogTitle = '审核';
                this.setMainDialogStyle('-80px', '70vh');
                this.dialogVisible = true;
                this.fieldVisible = false;
                this.auditAreaVisible = true;
            },
            //审核后回调函数
            auditCallback(auditInfo){
                this.dialogVisible = false;
                auditInfo.changeCode = this.selectRowData.changeCode;
                auditInfo.stuCode = this.selectRowData.stuCode;
                auditInfo.newClassCode = this.selectRowData.newClassCode;

                this.updateStuState(auditInfo);
            },
            //完成审核后更新学生信息
            updateStuState(auditInfo){
                this.$api.student.status.updateAuditState({
                    data: auditInfo,
                }).then((response) => {
                    let state = response.data.data.state;
                    if(state == 'Success'){
                        //更新学生信息
                        if(response.data.data.updateStuInfo == 'true'){
                            for(let i=0; i<this.students.length; i++){
                                if(this.students[i].stuCode == this.selectRowData.stuCode){
                                    this.students[i].majorCode = this.selectRowData.newMajorCode;
                                    this.students[i].majorName = this.selectRowData.newMajorName;
                                    this.students[i].classCode = this.selectRowData.newClassCode;
                                    this.students[i].className = this.selectRowData.newClassName;

                                    break;
                                }
                            }
                        }
                    }else{
                        showNotify('失败', '学籍信息更新失败', 'error', 3000);
                    }

                    this.requeryList();
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            //显示审核详情列表
            showAuditList(rowData){
                this.selectRowData = rowData;
                this.auditListDialogVisible = true;
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
            setMainDialogStyle(top, height){
                document.getElementById('mainDialog').style.top = top;
                this.$nextTick(() => {
                    document.getElementById('mainDialogScroll').style.height = height;
                });
            },
            restoreScroll(){
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
        },
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode {
        line-height: 0;
    }

    #mobileMode #queryDialog {
        top: 130px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// statusApply.vue?0d5a428e